import { useIsAuthenticated } from '@codexporer.io/expo-amplify-auth';
import { getModule } from './module';

export const useUserSubscriptionType = () => {
    const { useGetSubscriptionType } = getModule();
    const isAuthenticated = useIsAuthenticated();
    const subscriptionType = useGetSubscriptionType() ?? undefined;
    return isAuthenticated ? subscriptionType : undefined;
};
